module.exports = __webpack_public_path__ + "img/twitter.86edca03.jpg";